var exports = {
  "title": "x43cbe9c2--c0d0ba--title",
  "container": "x43cbe9c2--c0d0ba--container",
  "tablet": "x43cbe9c2--c0d0ba--tablet",
  "phone": "x43cbe9c2--c0d0ba--phone",
  "description": "x43cbe9c2--c0d0ba--description",
  "sale": "x43cbe9c2--c0d0ba--sale",
  "rent": "x43cbe9c2--c0d0ba--rent",
  "host": "x43cbe9c2--c0d0ba--host",
  "wrapper": "x43cbe9c2--c0d0ba--wrapper",
  "textblock": "x43cbe9c2--c0d0ba--textblock",
  "image": "x43cbe9c2--c0d0ba--image",
  "apartment": "x43cbe9c2--c0d0ba--apartment",
  "suburban": "x43cbe9c2--c0d0ba--suburban",
};

module.exports = exports;
